import React from 'react';

import styled from 'styled-components/native';

const Wrapper = styled.View`
  flex: 1;
`;

const PageWrapper: React.FC = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default PageWrapper;
